export const workerTimeout = duration => {
  return `
    onmessage = function(event) {
      if (event.data === 'start') {
        timeout = setTimeout(() => {
          postMessage(null);
        }, ${duration});
      }
    };
  `;
};
